export default __webpack_public_path__ + "static/uizard-logo-icon-embossed-light-mode-1e432f6090148e645236f9f3ad44d69d.png";